import { useSelector } from 'react-redux';

import { SignalsGrid } from './signals-grid';
import { Content } from './signals.styled';

export const Signals = ({ id }) => {
  const signals = useSelector((store) => {
    const out = [];
    const items = store.events.events[id];
    for (let key in items) {
      out.push(items[key]);
    }
    return out;
  });

  /**
   * get events
   * @returns
   */
  const getEvents = () => {
    const out = [];
    if (signals) {
      for (let key in signals) {
        out.push(signals[key]);
      }
    }

    out.sort((x, y) => {
      return y.timestamp - x.timestamp;
    });

    return out;
  };

  const events = getEvents();

  return (
    <Content>
      <SignalsGrid source={id} signals={events} />
    </Content>
  );
};
